import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography
} from '@mui/material';
import _ from 'lodash';
import {
  appEvents,
  CSVField,
  validationUtil
} from 'modules';
import * as yup from 'yup';

import * as dataService from './dataService';



export interface IProps {}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useUploadInvestmentAreasModal();
  const [rows, setRows] = React.useState<ICSVRow[]>([]);
  const [hasError, setHasError] = React.useState(false);



  function handleClose() {
    appEvents.broadcast({
      type: 'modal',
      args: 'close'
    });
  }



  async function handleClickConfirm() {
    await tuple.mutations.bulkImportInvestmentAreas(_.map(rows, r => r.displayName));
    handleClose();
  }



  return (
    <Dialog
      open
      maxWidth={hasError ? 'xl' : undefined}
      onClose={() => !tuple.loading && handleClose()}>

      <DialogTitle></DialogTitle>

      <DialogContent style={{ width: hasError? '1024px' : undefined }}>
        <Stack spacing={1}>
          <Typography variant="body2">
            Select a CSV file from your device containing a list of investment areas to add to our system.
          </Typography>

          <CSVField.FC
            disabled={tuple.loading}
            rowValidator={__csvSchema}
            onSuccess={results => {
              setRows(results);
              setHasError(false);
            }}
            onError={() => {
              setRows([]);
              setHasError(true);
            }}
            onDelete={() => setRows([])} />

          {!_.isEmpty(rows) && (
            <Typography>CSV has {rows.length} rows to import.</Typography>
          )}
        </Stack>
      </DialogContent>



      <DialogActions>
        <Button
          variant="outlined"
          color="secondary"
          disabled={tuple.loading}
          onClick={handleClose}>
          Cancel
        </Button>

        <Button
          disabled={tuple.loading || hasError || _.isEmpty(rows)}
          onClick={handleClickConfirm}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};



const __csvSchema = yup.object({
  displayName: validationUtil.nonEmptyStringSchema.required()
}).required();

type ICSVRow = yup.InferType<typeof __csvSchema>;
